import { Select } from '@material-ui/core';
import styled from 'styled-components';

export const StyledSecondaryButton = {
  color: '#FF3400',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  fontFamily: 'Roboto',
  textTransform: 'unset',
  padding: '8px',
  borderRadius: '4px',
  border: '1px solid #FF523A',
};

export const StyledSelect = styled(Select)`
  &.MuiInput-underline.Mui-disabled:before {
    border-bottom-style: solid;
  }
  .MuiSelect-icon {
    color: black;
  }
  font-weight: 500;
`;

export const Container = styled.div`
  &&.container {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }
  .MuiPaper-root {
    box-shadow: 0px 1px 3px #0000001f;
  }
  .victim-bloc-title {
    text-align: left;
    font-size: 24px;
    white-space: nowrap;
    letter-spacing: 0;
    margin-left: 10px;
    font-weight: 500;
    font-family: Roboto;

    color: #2b2727;
  }

  .item-container {
    display: flex;
  }
  .item {
    background-color: #fff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    height: fit-content;
    color: #2b2727;
    font-size: 13px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    padding: 10px;
    min-width: 140px;
    margin: 5px 14px 5px 0px;
  }
  .subContainer {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .input {
    width: 23%;
    margin-bottom: 33px;
    font-size: 14px;
    .input-checkbox {
      margin-right: 30px;
    }
  }
  .input-gender {
    margin-left: 15px;
  }
  .input-1-3 {
    width: 25%;
    margin-bottom: 20px;
  }
  .input-2-3 {
    width: 100%;
    margin-bottom: 20px;
  }
  .input-3 {
    width: 32%;
    margin-bottom: 20px;
  }
  .input-4 {
    width: 90%;
    margin-bottom: 20px;
    margin-left: 20px;
  }
  .input-4-1 {
    width: 90%;
    margin-bottom: 20px;
  }

  .checkdiv {
    align-items: center;
    display: flex;
    margin-top: -18px;
    margin-bottom: -40px;
  }
  .text {
    text-align: left;
    font-size: 15px;
    color: #374065;
    margin-right: 17px;
    font-weight: bold;
    font-family: Roboto;
  }
  .deceased-title {
    font-size: 20px;
    margin-bottom: 10px;
    display: flex;
  }
  .victime-title-div {
    width: 98%;
    height: 36px;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    margin-bottom: 15px;
    position: relative;
  }
  .victime-title {
    text-align: left;
    font: 14px;
    font-weight: bold;
    letter-spacing: 0;
    color: #0072c6;
    margin-left: 10px;
    top: 50%;
    position: absolute;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .delete-title {
    text-align: left;
    font: 14px;
    font-weight: bold;
    letter-spacing: 0;
    color: #384164;
    margin-left: 10px;
    top: 50%;
    position: absolute;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    display: flex;
    justify-content: space-around;
  }
  .delete-victime {
    float: right;
    margin-left: 90%;
    display: flex;
    flex-direction: column;
    cursor: pointer;
  }
  .delete-icon {
    color: #384164;
    top: 50%;
    right: 9.5%;
    position: absolute;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .add-victim-paper {
    width: 160px;
    height: 106px;
    border-radius: 5px;
    background: #f8f8f8;
  }
  .victim-container {
    left: 328px;
    margin-top: 20px;
    margin-bottom: 25px;
    width: 100%;
  }
  .add-viction-btn {
    width: 160px;
    height: 36px;
    text-align: center;
    font-size: 14px;
  }
  .add-beneficiary-btn {
    margin-left: auto;
  }
  .add-victim-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 160px;
    height: 106px;
    border-radius: 5px;
  }
  .add-eligibility-victim {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    height: 106px;
    border-radius: 5px;
  }
  .add-eligibilty-btn {
    width: 160px;
    height: 36px;
    text-align: center;
    font-size: 14px;
  }
  .iconDiv {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .icon {
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    border-radius: 30px;
    background: #f2f2f2;
    margin-bottom: 10px;
  }
  .victims {
    margin-top: 30px;
  }
  .label-input {
    font-size: 13px;
  }
  .MuiFormLabel-root {
    font-size: 13px;
    color: #4f4f4f;
  }
  .MuiInputLabel-shrink {
    color: #00000061;
  }
  .MuiFormLabel-root.Mui-focused {
    color: rgba(9, 122, 194, 1);
  }
  .error {
    margin-top: -5px;
    color: red;
    text-align: center;
  }
  .deceaseBlock {
    margin-bottom: 40px;
  }
  .beneficiary {
    margin-bottom: 10px;
  }
  .accordion-form-container {
    margin-top: '30px';
    margin-inline: '25px';
  }
  .MuiInputLabel-shrink {
    font-size: 20px;
    color: #666;
  }
  .MuiInputBase-input.Mui-disabled {
    font-weight: 500;
  }
  .MuiAutocomplete-inputRoot .MuiAutocomplete-input {
    font-weight: 500;
  }
  .victim-bloc-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: flex-start !important;
    margin-top: -5px !important;
  }
  .grid-input {
    margin-bottom: 15px;
  }
`;
